var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconService1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_27959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0469 21.71V23.8742",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0469 10.9746V12.9889",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0466 29.1461C22.5466 29.1461 27.9037 26.489 27.9037 20.5747C27.9037 14.1461 24.6895 9.86038 18.2609 6.64609L20.7895 3.38895C20.9179 3.17525 20.9876 2.93138 20.9914 2.68206C20.9953 2.43275 20.9331 2.18686 20.8113 1.9693C20.6894 1.75175 20.5123 1.57027 20.2977 1.44327C20.0831 1.31626 19.8388 1.24824 19.5895 1.24609H10.5037C10.2544 1.24824 10.0101 1.31626 9.7955 1.44327C9.58093 1.57027 9.40375 1.75175 9.28192 1.9693C9.16009 2.18686 9.09794 2.43275 9.10177 2.68206C9.1056 2.93138 9.17528 3.17525 9.30374 3.38895L11.8323 6.66752C5.40374 9.90324 2.18945 14.189 2.18945 20.6175C2.18945 26.489 7.5466 29.1461 15.0466 29.1461Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9042 20.7245C13.1657 21.0348 13.4948 21.2812 13.8662 21.4446C14.2377 21.608 14.6416 21.6842 15.0471 21.6673C15.6668 21.7096 16.2788 21.5099 16.7543 21.1103C17.2299 20.7106 17.532 20.1422 17.5971 19.5245C17.532 18.9067 17.2299 18.3383 16.7543 17.9386C16.2788 17.539 15.6668 17.3393 15.0471 17.3816C14.4273 17.4238 13.8154 17.2242 13.3398 16.8245C12.8643 16.4249 12.5622 15.8565 12.4971 15.2387C12.557 14.6188 12.8576 14.0471 13.3344 13.6465C13.8112 13.2458 14.4261 13.0481 15.0471 13.0959C15.4454 13.0715 15.8442 13.1357 16.2147 13.284C16.5852 13.4322 16.9183 13.6607 17.1899 13.953",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_27959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.046875 0.239258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconService1);
export default __webpack_public_path__ + "static/media/icon-service-1.fbf96c9d8b784d7a18c257372b7adf88.svg";
export { ForwardRef as ReactComponent };